import TableContainer from '../../../../_table-container';
import ReactionModal from '../../../../_modals/reaction';
import HeatDiagram from '../../../../_heat-diagram';
import { AlertTypes } from "../../../../../constants/alert_types";
import { mapActions } from 'vuex';
import { AlertStatuses } from "../../../../../constants/alert_statuses";
import UtilsService from "../../../../../services/UtilsService";
import AlertsApi from "../../../../../api/alerts-api";
import { onMounted } from 'vue';


export default {
  name: 'BaseAlertsTable',
  props: {
    searchText: String,
    tableTitle: String,
    tableData: Array,
    selectedFilter: Object,
    showInseminationColumn: Boolean,
    showFooter: Boolean,
    isActiveAlerts: {
      type: Boolean,
      default: false
    }
  },
  components: { TableContainer, HeatDiagram },
  watch: {
    selectedFilter: function (newVal) {
      this.allShown = false;
      this.type = newVal ? newVal.filter : null;
    }
  },
  data() {
    return {
      isModalOpen: false,
      modal: null,
      modalData: [],
      rowsPerPage: 50,
      allShown: false
    };
  },
  methods: {
    ...mapActions("alerts", {
      getAlerts: "getAlerts"
    }),
    /**
     * Opens the confirmation modal for the actual data
     * @param {event} event The button onClick raw event
     * @param {object} alert The alert data
     */
    async confirmation(event, alert) {
      event.stopPropagation();
      this.modalData = {
        alert: alert,
        modalName: alert.type && this.$t(`cowGenerics.cowLogs.${alert.type}`) + ' confirmation',
        reaction: "confirmed",
        reload: () =>
          this.fetchAlerts(this.selectedFilter, this.rowsPerPage, true)
      };

      const dataToSend = {
        confirmation: this.modalData.reaction,
        alert_time: UtilsService.utcDate(this.$moment()),
      };

      // Set loading and wait for data to be sent and response to be returned.
      await AlertsApi.post(this.modalData.alert.id, dataToSend);
      // Reload logs
      this.modalData.reload();
    },

    /**
     * Opens the dismissal modal for the actual data
     * @param {event} event The button onClick raw event
     * @param {object} d The cow data
     */
    async dismissal(event, alert) {
      event.stopPropagation(); // Stop the click event to propagate (navigate to other route)


      // Set up the modal data
      this.modalData = {
        alert: alert,
        modalName: alert.type && (this.$t(`cowGenerics.cowLogs.${alert.type}`) + ` dismissal`),
        reaction: "dismissed",
        reload: () =>
          this.fetchAlerts(this.selectedFilter, this.rowsPerPage, true)
      };

      const dataToSend = {
        confirmation: this.modalData.reaction,
        alert_time: UtilsService.utcDate(this.$moment()),
      };

      // Set loading and wait for data to be sent and response to be returned.
      await AlertsApi.post(this.modalData.alert.id, dataToSend);

      // Reload logs
      this.modalData.reload();
    },

    confirmAction(event, alert) {
      event.stopPropagation(); // Stop the click event to propagate (navigate to other route)

      const locale = [AlertTypes.Heat, AlertTypes.RepeatHeat].includes(alert.type) ? 'heat' : alert.type === AlertTypes.Calving ? 'calving' : undefined;
      // Set up the modal data
      this.modalData = {
        alert: alert,
        modalName: locale ? this.$t(`actions.${locale}.confirmAction`) : this.$t(`cowGenerics.cowLogs.${alert.type}`),
        reaction: "confirmed_with_action",
        reload: () =>
          this.fetchAlerts(this.selectedFilter, this.rowsPerPage, true)
      };
      this.modal = ReactionModal;
      // Open modal
      this.isModalOpen = true;
    },

    showMore() {
      this.rowsPerPage += 50;
      this.fetchAlerts(this.selectedFilter, this.rowsPerPage)
    },

    showAll() {
      this.fetchAlerts(this.selectedFilter)
    },

    fetchAlerts(selectedFilter, limit = undefined, all = false) {
      const alert_types = (selectedFilter && selectedFilter.filter) ? [selectedFilter.filter] : [
        AlertTypes.Heat,
        AlertTypes.RepeatHeat,
        AlertTypes.HighTemp,
        AlertTypes.LowTemp,
        // AlertTypes.PossibleMilkFever,
        AlertTypes.LowWaterIntake,
        AlertTypes.IncreasedActivity,
        AlertTypes.DecreasedActivity,
        AlertTypes.Calving
      ]
      this.getAlerts({
        with_cow: true,
        with_building: true,
        alert_types: alert_types,
        alert_statuses: [AlertStatuses.confirmed, AlertStatuses.confirmed_with_action, AlertStatuses.dismissed, AlertStatuses.expired],
        limit
      });
      if (all) {
        this.getAlerts({
          with_cow: true,
          with_building: true,
          alert_types: alert_types,
          alert_statuses: [AlertStatuses.active]
        })
        this.getAlerts({
          totals_only: true
        })
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_dashboard/alerts/table/base-alert-table/base-alert-table.js